<template>
  <div>
    <div class="traffic-map">
      <img width="100%" :src="traffic_1">
      <img width="100%" :src="traffic_2" @click="onClick(1)">
      <img width="100%" :src="traffic_3">
      <img width="100%" :src="traffic_4" @click="onClick(2)">
      <img width="100%" :src="traffic_5">
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const time = Date.now()
      return {
        traffic_1: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/shiji/1.png?_t=" + time,
        traffic_2: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/shiji/2.png?_t=" + time,
        traffic_3: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/shiji/3.png?_t=" + time,
        traffic_4: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/shiji/4.png?_t=" + time,
        traffic_5: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/shiji/5.png?_t=" + time,
      }
    },
    methods: {
      onClick(type) {
        if (type === 1) {
          window.location.href = 'https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/S1.jpg'
        } else if (type === 2) {
          window.location.href = 'https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/S2.png'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .traffic-map {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
</style>